import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from 'actions';
import { areResultsOwnedByUser } from 'selectors';

import { Button } from 'react-bootstrap';

class TagHideButton extends Component {
  hideTag = () => {
    const { tag, hideTags } = this.props;
    hideTags([tag]);
  };

  render() {
    const { tag, areResultsOwnedByUser } = this.props;
    if (!areResultsOwnedByUser) {
      return null;
    }
    return (
      <Button className="TagHideButton" onClick={this.hideTag}>
        Hide all {tag.name}
      </Button>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    areResultsOwnedByUser: areResultsOwnedByUser(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      hideTags: actions.hideTags,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TagHideButton);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Tags/TagHideButton.js